<template>
    <div class="equity-wrapper" :style="{backgroundColor:color}">
         <commonTop :banner="banner" :applyUrl="applyUrl"  ></commonTop>
         <template v-if="id=='qqgb'">
             <qqgb></qqgb>
         </template>
           <template v-else-if="id=='tsjc'">
             <tsjc></tsjc>
         </template>
           <template v-else-if="id=='xjjd'">
             <xjjd></xjjd>
         </template>
         <template v-else-if="id=='gdjd'">
             <gdjd></gdjd>
         </template>
         <template v-else-if="id=='gdty'">
             <gdty></gdty>
         </template>
         <template v-else-if="id=='geyw'">
             <geyw></geyw>
         </template>
          <template v-else-if="id=='hkyw'">
             <hkyw></hkyw>
         </template>
         <template v-else-if="id=='jchy'">
             <jchy></jchy>
         </template>
           <template v-else-if="id=='jwjs'">
             <jwjs></jwjs>
         </template>
           <template v-else-if="id=='qgjc'">
             <qgjc></qgjc>
         </template>
         
    </div>
</template>

<script>
import commonTop from '@/components/equityTop';
import qqgb from './qqgb';
import tsjc from './tsjc';
import xjjd from './xjjd';
import gdjd from './gdjd';
import gdty from './gdty';
import geyw from './geyw';
import hkyw from './hkyw';
import jchy from './jchy';
import jwjs from './jwjs';
import qgjc from './qgjc';

export default {
    data() {
        return { equity: "", id: "",banner:'',applyUrl:'',color:''};
    },
    components: {
        commonTop,
        qqgb,
        tsjc,
        xjjd,
        gdjd,
        gdty,
        geyw,
        hkyw,
        jchy,
        jwjs,
        qgjc
    },
    mounted() {
        this.equity = this.$route.params.equity;
        this.id = this.$route.params.id;
        console.log(this.id)
        this.initData()
    },
    methods:{
        initData(){
            this.banner=this.$store.state.equityData[this.equity][this.id].banner;
            this.applyUrl=this.$store.state.equityData[this.equity][this.id].applyUrl;
            this.color=this.$store.state.equityData[this.equity][this.id].color;

            
        }
    }
};
</script>

<style lang="scss" scoped>
</style>